<template>
    <v-dialog
        persistent
        v-model="openAddTruck"
        max-width="500px"
        transition="dialog-transition"
    >
        <v-card>
            <v-toolbar color="secondary" dark dense>
                <v-spacer></v-spacer>
                Add Truck
                <v-spacer></v-spacer>
                <v-btn dark icon left @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-form ref="form" lazy-validation v-model="valid">
                    <v-row>
                        <v-col>
                            <v-combobox
                                label="Select Trucks"
                                v-model="truck"
                                :items="trucks"
                                :item-text="'Truck'"
                                :item-value="'TruckID'"
                                auto-select-first
                                dense
                                hide-details
                                required
                                :rules="[v => !!v || 'Truck is required']"
                            ></v-combobox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                label="PayDate"
                                v-model="paydate"
                                dense
                                required
                                v-mask="'####/##/##'"
                                :rules="$store.state.dateRules"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="end">
                        <v-col cols="2">
                            <v-btn color="secondary" @click="validate"
                                >Add</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
export default {
    directives: { mask },
    props: ['openAddTruck', 'trucks', 'period'],
    data: function() {
        return {
            truck: null,
            valid: true,
            paydate: ''
        };
    },
    methods: {
        validate() {
            if (this.$refs.form.validate()) {
                this.saveAddTruck();
            } else {
                this.$refs.form.validate();
            }
        },

        saveAddTruck: function() {
            var str = this.$store;
            var parms = {
                Truck: this.truck.TruckID,
                PayDate: this.paydate,
                EfectiveDateEnd: this.period.EfectiveDateEnd,
                EfectiveDateStart: this.period.EfectiveDateStart
            };
            console.log(parms);
            str.state.isLoading = true;
            axios
                .post('ext-expense/add/truck', parms)
                .then(response => {
                    console.log(response.data);
                    this.$emit('close');
                    this.$emit('recall');
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        }
    }
};
</script>
